/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolUmbrellaIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-umbrella"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M13.32 12.78L14.45 9.3L13.97 9.43L13.32 8.95ZM10.68 12.8L10.68 8.95L10.03 9.45L9.53 9.32ZM12 22.32Q12 22.32 11.8 22.32Q11.6 22.32 11.25 22.09Q10.9 21.85 10.75 21.43L6.25 7.9Q6 7.15 6.54 6.56Q7.08 5.97 7.83 6.17L9.43 6.58L10.68 5.63L10.68 3.4Q10.68 2.27 11.5 1.48Q12.32 0.68 13.5 0.68Q14.68 0.68 15.5 1.48Q16.32 2.27 16.32 3.4Q16.32 3.95 15.94 4.34Q15.55 4.72 15 4.72Q14.45 4.72 14.06 4.34Q13.68 3.95 13.68 3.4Q13.68 3.35 13.63 3.3Q13.57 3.25 13.5 3.25Q13.43 3.25 13.38 3.3Q13.32 3.35 13.32 3.4L13.32 5.63L14.57 6.58L16.18 6.17Q16.93 5.97 17.46 6.56Q18 7.15 17.75 7.9L13.25 21.4Q13.1 21.85 12.75 22.09Q12.4 22.32 12 22.32Z" fill={color} />
    </svg>
  );
}
